import styled, { css } from 'styled-components';

import isMobile from '~/utils/is-mobile';

export const Wrap = styled.div`
  position: relative;
`;

export const VideoWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: transparent;
  background-size: cover;
  position: relative;

  > video {
    object-fit: cover;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  > button {
    width: 72%;
    height: 4.5%;
    background-color: transparent;
    border: 0;
    cursor: pointer;
    position: absolute;
    bottom: 2%;
    left: 50%;
    transform: translateX(-50%);
  }
`;
